import { Route, Navigate, Routes, BrowserRouter } from "react-router-dom";
import { AdminProvider, useAdminPermissions } from "./context/AdminContext";
import Home from "./pages/Home";
import Users from "./pages/Users";
import Billing from "./pages/Billing";
import Profile from "./pages/Profile";
import SignUp from "./pages/SignUp";
import SignIn from "./pages/SignIn";
import Main from "./components/layout/Main";
import "antd/dist/antd.css";
import "./assets/styles/main.css";
import "./assets/styles/responsive.css";
import Organisations from "./pages/Organisations";
import Transactions from "./pages/Transactions";
import Supply from "./pages/Supply";
import Qr from "./pages/Qr";
import Commercial from "./pages/Commercial";
import OrganisationDetails from "./pages/OrganisationDetails";
import { Spin } from "antd";
import UserDetails from "./pages/UserDetails";
import CommercialDetails from "./pages/CommercialDetails";
import Airtime from "./pages/Airtime";
import UserVerifications from "./pages/UserVerification";
import UserVerificationDetails from "./pages/UserVerificationDetails";
import AdminManagement from "./pages/AdminManagement";
import OrganisationLimits from "./pages/OrganisationLimit";
import OrganisationLimitDetail from "./pages/OrganisationLimitDetail";
import OrganisationVerificationDetails from "./pages/OrganisationVerificationDetails";
import OrganisationVerification from "./pages/OrganisationVerification";

// Composant de route protégée réutilisable
function AdminRoute({ children, route }) {
  const { ProtectedRoute } = useAdminPermissions();

  return <ProtectedRoute requiredRoute={route}>{children}</ProtectedRoute>;
}

// Composant principal des routes internes
function AppRoutes() {
  return (
    <Routes>
      {/* Routes publiques */}
      <Route path="/sign-up" element={<SignUp />} />
      <Route path="/sign-in" element={<SignIn />} />

      {/* Layout principal avec routes protégées */}
      <Route element={<Main />}>
        <Route
          path="/dashboard"
          element={
            <AdminRoute route="/dashboard">
              <Home />
            </AdminRoute>
          }
        />
        <Route
          path="/users"
          element={
            <AdminRoute route="/users">
              <Users />
            </AdminRoute>
          }
        />
        <Route
          path="/users/:userUuid"
          element={
            <AdminRoute route="/users/:userUuid">
              <UserDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/billing"
          element={
            <AdminRoute route="/billing">
              <Billing />
            </AdminRoute>
          }
        />
        <Route
          path="/profile"
          element={
            <AdminRoute route="/profile">
              <Profile />
            </AdminRoute>
          }
        />
        <Route
          path="/organisations"
          element={
            <AdminRoute route="/organisations">
              <Organisations />
            </AdminRoute>
          }
        />
        <Route
          path="/organisations/:organisationId"
          element={
            <AdminRoute route="/organisations/:organisationId">
              <OrganisationDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <AdminRoute route="/transactions">
              <Transactions />
            </AdminRoute>
          }
        />
        <Route
          path="/transactions/:transactionId"
          element={
            <AdminRoute route="/transactions/:transactionId">
              <Transactions />
            </AdminRoute>
          }
        />
        <Route
          path="/supply"
          element={
            <AdminRoute route="/supply">
              <Supply />
            </AdminRoute>
          }
        />
        <Route
          path="/qr-code"
          element={
            <AdminRoute route="/qr-code">
              <Qr />
            </AdminRoute>
          }
        />
        <Route
          path="/commercials"
          element={
            <AdminRoute route="/commercials">
              <Commercial />
            </AdminRoute>
          }
        />
        <Route
          path="/commercials/:uuid"
          element={
            <AdminRoute route="/commercials/:uuid">
              <CommercialDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/airtime"
          element={
            <AdminRoute route="/airtime">
              <Airtime />
            </AdminRoute>
          }
        />
        <Route
          path="/verification"
          element={
            <AdminRoute route="/verification">
              <UserVerifications />
            </AdminRoute>
          }
        />
        <Route
          path="/verification/:user_uuid"
          element={
            <AdminRoute route="/verification/:user_uuid">
              <UserVerificationDetails />
            </AdminRoute>
          }
        />
        <Route
          path="/admin-management"
          element={
            <AdminRoute route="/admin-management">
              <AdminManagement />
            </AdminRoute>
          }
        />
        {/*organisations Limits Routes */}
        <Route
          path="/organisations/limits"
          element={
            <AdminRoute route="/organisations/limits">
              <OrganisationLimits />
            </AdminRoute>
          }
        />
        <Route
          path="/organisations/:organisationId/limits"
          element={
            <AdminRoute route="/organisations/:organisationId/limits">
              <OrganisationLimitDetail />
            </AdminRoute>
          }
        />{" "}
        {/* Routes pour les KYB */}
        <Route
          path="/organisation-verification"
          element={
            <AdminRoute route="/organisation-verification">
              <OrganisationVerification />
            </AdminRoute>
          }
        />
        <Route
          path="/organisation-verification/:organisationId"
          element={
            <AdminRoute route="/organisation-verification/:organisationId">
              <OrganisationVerificationDetails />
            </AdminRoute>
          }
        />
        *{/* Redirection */}
        <Route path="*" element={<Navigate to="/dashboard" />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AdminProvider>
        <AppRoutes />
      </AdminProvider>
    </BrowserRouter>
  );
}

export default App;
